import React, { useState, useRef } from "react";
import ButtonGroup from "@atlaskit/button/button-group";
import Button from "@atlaskit/button/standard-button";
import DetailViewIcon from "@atlaskit/icon/glyph/detail-view";
import RetryIcon from "@atlaskit/icon/glyph/retry";
import Select from "@atlaskit/select";
import SearchIcon from "@atlaskit/icon/glyph/search";
import Textfield from "@atlaskit/textfield";
import Form, {
  Field,
  FormFooter,
  FormSection,
  ErrorMessage,
} from "@atlaskit/form";
import ProgressTrack from "../../Shared/ProgressTracker/ProgressTrack";
import {
  sortAlhabetically,
  sortAlhabeticallyname,
  sortAlhabeticallyproject,
  sortIt,
} from "../../../helpers/helpers";
import RestoreExportSection from "../RestoreExport/RestoreExportSection/RestoreExportSection";
import RestoreExportFooter from "../RestoreExport/RestoreExportFooter/RestoreExportFooter";
import RestoreConfigSection from "../RestoreConfig/RestoreConfigSection/RestoreConfigSection";

import { restoreTypes } from "../../../constants/constants";

import styles from "./RestoreFilter.module.css";

const RestoreFilter = (props) => {
  const validateSummary = useRef("");
  const validateDescription = useRef("");
  const newSnapshotDates = props.snapshotDates.map((dt) => {
    return {
      snapshotName: dt.snapshotName,
      snapshotId: dt.snapshotId,
      tag: dt.tag,
    };
  });
  const sortedDates = newSnapshotDates.sort(sortIt("snapshotName"));

  const formattedSnapshotDates = sortedDates.map((dt) => {
    return {
      snapshotName: new Date(dt.snapshotName).toUTCString(),
      snapshotId: dt.snapshotId,
      tag: dt.tag,
    };
  });

  const CustomStyle = (val) => {
    return {
      singleValue: (base) => ({
        ...base,
        width: "100%",
      }),

      valueContainer: (base) => ({
        ...base,
      }),
    };
  };

  const formatOptionLabel = ({ snapshotId, snapshotName, tag }) => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        {/* <div>{snapshotName}</div>
        <div style={{ marginLeft: "10px", color: "#6B778C" }}>
          {tag ? tag : ""}
        </div> */}
        <div>{snapshotName}</div>
        <div>{tag ? tag : ""}</div>
      </div>
    );
  };

  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      {props.restoreType === "restore_backed_up_issues_as_new_issues" ||
      props.restoreType === "restore_configuration" ? (
        <>
          <div className={styles.tracker}>
            <div className={styles.trackerItem}>
              <ProgressTrack data={props.progressTrack} />
            </div>
          </div>
        </>
      ) : (
        <br />
      )}

      <div className={styles.container}>
        <div className={styles.item}>
          <Form
            onSubmit={(data) => {
              if (
                props.restoreType === "restore_backed_up_issues_as_new_issues"
              ) {
                const issueStatus = data.status
                  ? data.status.map((data) => {
                      return data.statusId;
                    })
                  : [];
                const filterData = {
                  snapshotId: data.snapshotDate.snapshotId,
                  projectId: data.project.projectId,
                  issueTypeId: data.issueType.issueTypeId,
                  issueStatusId: issueStatus,
                  searchText: data.searchText,
                  searchDescription: data.searchDescription,
                };

                props.handleMapField(filterData);
              } else if (props.restoreType === "restore_configuration") {
                const filterData = {
                  snapshotId: data.snapshotDate.snapshotId,
                  configType: data.config.value,
                };
                props.handleConfigField(filterData);
              } else {
                if (
                  props.formStateData.projects !== null &&
                  props.formStateData.snapshotDate !== null
                ) {
                  setIsOpen(!isOpen);
                }
              }
            }}
            isDisabled={props.isLoading}
          >
            {({ formProps }) => (
              <form {...formProps}>
                <FormSection>
                  <Field
                    label="Data recovery action"
                    name="whatToRestore"
                    id="whatToRestore"
                    // defaultValue={{
                    //   value: "restore_backed_up_issues_as_new_issues",
                    //   label: "Create issues (as new issues)",
                    // }}
                    defaultValue={
                      props.restoreType ===
                      "restore_backed_up_issues_as_new_issues"
                        ? {
                            value: "restore_backed_up_issues_as_new_issues",
                            label: "Create issues (as new issues)",
                          }
                        : props.restoreType === "restore_configuration"
                        ? {
                            value: "restore_configuration",
                            label: "Configurations",
                          }
                        : {}
                    }
                    isRequired
                  >
                    {({ fieldProps: { id, ...rest } }) => (
                      <Select
                        id={`${id}-select`}
                        isSearchable={false}
                        options={restoreTypes}
                        {...rest}
                        onChange={(value) => {
                          props.setFormStateData({
                            project: null,
                            issueType: null,
                            status: null,
                            snapshotDate: null,
                            configType: null,
                          });
                          props.handleRestoreType(value.value);
                          rest.onChange(value);
                        }}
                      />
                    )}
                  </Field>
                  <Field
                    aria-required={true}
                    name="snapshotDate"
                    id="snapshotDate"
                    label="Snapshot date"
                    isRequired
                    defaultValue={props.formStateData.snapshotDate}
                    validate={async (value) => {
                      if (value) {
                        return undefined;
                      }

                      return new Promise((resolve) =>
                        setTimeout(resolve, 300)
                      ).then(() => "Please select a snapshot date");
                    }}
                  >
                    {({ fieldProps: { id, ...rest }, error }) => (
                      <>
                        <Select
                          noOptionsMessage={({ inputValue }) =>
                            !inputValue ? "No snapshots options" : ""
                          }
                          name="snapshotDate"
                          getOptionLabel={(option) => option.snapshotName}
                          getOptionValue={(option) => option.snapshotId}
                          id={`${id}-select`}
                          options={formattedSnapshotDates}
                          formatOptionLabel={formatOptionLabel}
                          styles={CustomStyle(props.formStateData.snapshotDate)}
                          placeholder="Select snapshot date"
                          {...rest}
                          onChange={(value) => {
                            props.setFormStateData({
                              ...props.formStateData,
                              project: null,
                              issueType: null,
                              status: null,
                              snapshotDate: value,
                              configType: null,
                            });
                            rest.onChange(value);
                            props.handleSnapshotDate(value);
                            if (props.restoreType === "restore_configuration")
                              props.handleProgressTrack("snapshotSelected");
                          }}
                          validationState={
                            !rest.isDisabled && error ? "error" : "default"
                          }
                        />
                        {!rest.isDisabled && error && (
                          <ErrorMessage>{error}</ErrorMessage>
                        )}
                      </>
                    )}
                  </Field>
                  {props.restoreType ===
                  "restore_backed_up_issues_as_new_issues" ? (
                    <Field
                      aria-required={true}
                      name="project"
                      id="project"
                      label="Projects"
                      isRequired
                      isDisabled={props.projects.length === 0 ? true : false}
                      defaultValue={props.formStateData.project}
                      validate={async (value) => {
                        if (value) {
                          return undefined;
                        }

                        return new Promise((resolve) =>
                          setTimeout(resolve, 300)
                        ).then(() => "Please select a project");
                      }}
                    >
                      {({ fieldProps: { id, ...rest }, error }) => (
                        <>
                          <Select
                            noOptionsMessage={({ inputValue }) =>
                              !inputValue ? "No project options" : ""
                            }
                            getOptionLabel={(option) => option.projectName}
                            getOptionValue={(option) => option.projectId}
                            id={`${id}-select`}
                            options={sortAlhabeticallyproject(props.projects)}
                            placeholder="Select project"
                            {...rest}
                            onChange={(value) => {
                              props.setFormStateData({
                                ...props.formStateData,
                                issueType: null,
                                status: null,
                                project: value,
                                configType: null,
                              });
                              rest.onChange({
                                projectName: value.projectName,
                                projectId: value.projectId,
                              });
                              props.handleProjectData(value);
                            }}
                            validationState={
                              !rest.isDisabled && error ? "error" : "default"
                            }
                          />
                          {!rest.isDisabled && error && (
                            <ErrorMessage>{error}</ErrorMessage>
                          )}
                        </>
                      )}
                    </Field>
                  ) : (
                    ""
                  )}
                  {props.restoreType ===
                  "restore_backed_up_issues_as_new_issues" ? (
                    <Field
                      aria-required={true}
                      name="issueType"
                      id="issueType"
                      label="Issue Type"
                      isDisabled={props.issueTypes.length === 0 ? true : false}
                      isRequired
                      defaultValue={props.formStateData.issueType}
                      validate={async (value) => {
                        if (value) {
                          return undefined;
                        }

                        return new Promise((resolve) =>
                          setTimeout(resolve, 300)
                        ).then(() => "Please select issue type");
                      }}
                    >
                      {({ fieldProps: { id, ...rest }, error }) => (
                        <>
                          <Select
                            noOptionsMessage={({ inputValue }) =>
                              !inputValue ? "No issue type options" : ""
                            }
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.issueTypeId}
                            id={`${id}-select`}
                            options={sortAlhabeticallyname(props.issueTypes)}
                            placeholder="Select issue type"
                            {...rest}
                            validationState={
                              !rest.isDisabled && error ? "error" : "default"
                            }
                            onChange={(value) => {
                              props.setFormStateData({
                                ...props.formStateData,
                                issueType: value,
                              });
                              rest.onChange(value);
                            }}
                          />
                          {!rest.isDisabled && error && (
                            <ErrorMessage>{error}</ErrorMessage>
                          )}
                        </>
                      )}
                    </Field>
                  ) : (
                    ""
                  )}
                  {props.restoreType ===
                  "restore_backed_up_issues_as_new_issues" ? (
                    <Field
                      aria-required={true}
                      name="status"
                      id="status"
                      label="Issue Status"
                      defaultValue={props.formStateData.status}
                      isDisabled={props.status.length === 0 ? true : false}
                    >
                      {({ fieldProps: { id, ...rest }, error }) => (
                        <Select
                          noOptionsMessage={({ inputValue }) =>
                            !inputValue ? "No issue status options" : ""
                          }
                          getOptionLabel={(option) => option.name}
                          getOptionValue={(option) => option.statusId}
                          id={`${id}-select`}
                          options={sortAlhabeticallyname(props.status)}
                          placeholder="Select status"
                          isMulti
                          {...rest}
                          validationState={
                            !rest.isDisabled && error ? "error" : "default"
                          }
                          onChange={(value) => {
                            props.setFormStateData({
                              ...props.formStateData,
                              status: value,
                            });
                            rest.onChange(value);
                          }}
                        />
                      )}
                    </Field>
                  ) : (
                    ""
                  )}
                  {props.restoreType ===
                  "restore_backed_up_issues_as_new_issues" ? (
                    <Field
                      label="Search in issue summary"
                      name="searchText"
                      defaultValue={props.formStateData.searchText}
                      validate={async (value) => {
                        const regexp = new RegExp("^[ A-Za-z0-9@#_-]*$");
                        if (regexp.test(value)) {
                          return undefined;
                        } else {
                          return "Only alphanumeric characters and '@', '#', '_', '-' Are Allowed.";
                        }
                      }}
                    >
                      {({ fieldProps, error }) => (
                        <>
                          <Textfield
                            elemBeforeInput={
                              <div
                                style={{
                                  paddingLeft: "6px",
                                  lineHeight: "100%",
                                }}
                              >
                                <SearchIcon
                                  size="small"
                                  borderColor="transparent"
                                />
                              </div>
                            }
                            placeholder="Enter keywords to search in Issue summary"
                            {...fieldProps}
                            onChange={(value) => {
                              props.setFormStateData({
                                ...props.formStateData,
                                searchText: value.target.value,
                              });
                              fieldProps.onChange(value);
                              const regexp = new RegExp("^[ A-Za-z0-9@#_-]*$");

                              if (regexp.test(value.target.value)) {
                                validateSummary.current = "";
                              } else {
                                validateSummary.current = "error";
                              }
                            }}
                          />
                          {error && <ErrorMessage>{error}</ErrorMessage>}
                          {/* <HelperMessage>
                            Only alphanumeric characters and "@", "#", "_", "-"
                            Are Allowed.
                          </HelperMessage> */}
                        </>
                      )}
                    </Field>
                  ) : (
                    ""
                  )}
                  {props.restoreType ===
                  "restore_backed_up_issues_as_new_issues" ? (
                    <Field
                      label="Search in issue description"
                      name="searchDescription"
                      defaultValue={props.formStateData.searchDescription}
                      validate={async (value) => {
                        const regexp = new RegExp("^[ A-Za-z0-9@#_-]*$");
                        if (regexp.test(value)) {
                          return undefined;
                        } else {
                          return "Only alphanumeric characters and '@', '#', '_', '-' Are Allowed.";
                        }
                      }}
                    >
                      {({ fieldProps, error }) => (
                        <>
                          <Textfield
                            elemBeforeInput={
                              <div
                                style={{
                                  paddingLeft: "6px",
                                  lineHeight: "100%",
                                }}
                              >
                                <SearchIcon
                                  size="small"
                                  borderColor="transparent"
                                />
                              </div>
                            }
                            placeholder="Enter keywords to search in Issue description"
                            {...fieldProps}
                            onChange={(value) => {
                              props.setFormStateData({
                                ...props.formStateData,
                                searchDescription: value.target.value,
                              });
                              fieldProps.onChange(value);
                              const regexp = new RegExp("^[ A-Za-z0-9@#_-]*$");

                              if (regexp.test(value.target.value)) {
                                validateDescription.current = "";
                              } else {
                                validateDescription.current = "error";
                              }
                            }}
                          />
                          {error && <ErrorMessage>{error}</ErrorMessage>}
                          {/* <HelperMessage>
                            Only alphanumeric characters and "@", "#", "_", "-"
                            Are Allowed.
                          </HelperMessage> */}
                        </>
                      )}
                    </Field>
                  ) : (
                    ""
                  )}
                  {props.restoreType === "restore_export" ? (
                    <RestoreExportSection
                      setFormStateData={props.setFormStateData}
                      formStateData={props.formStateData}
                      projects={props.projects}
                      issueTypes={props.issueTypes}
                      status={props.status}
                      isLoading={props.isLoading}
                      handleProjectData={props.handleProjectData}
                      handleMapField={props.handleMapField}
                      handleFormReset={props.handleModal}
                    />
                  ) : (
                    ""
                  )}
                  {props.restoreType === "restore_configuration" ? (
                    <RestoreConfigSection
                      setFormStateData={props.setFormStateData}
                      formStateData={props.formStateData}
                      projects={props.projects}
                      isLoading={props.isLoading}
                      handleProgressTrack={props.handleProgressTrack}
                      handleFormReset={props.handleModal}
                    />
                  ) : (
                    ""
                  )}
                </FormSection>
                <div className={styles.formfooter}>
                  <FormFooter>
                    {props.restoreType === "restore_export" ? (
                      <RestoreExportFooter
                        isLoading={props.isLoading}
                        handleFormReset={props.handleFormReset}
                        handleExportData={props.handleExportData}
                        formStateData={props.formStateData}
                        isOpen={isOpen}
                        setIsOpen={setIsOpen}
                      />
                    ) : (
                      ""
                    )}

                    {props.restoreType ===
                      "restore_backed_up_issues_as_new_issues" ||
                    props.restoreType === "restore_configuration" ? (
                      <ButtonGroup>
                        <Button
                          iconBefore={<RetryIcon label="Reset" size="medium" />}
                          isDisabled={props.isLoading}
                          appearance="default"
                          id="mapFieldsReset"
                          onClick={props.handleFormReset}
                        >
                          Reset
                        </Button>

                        <Button
                          iconBefore={
                            <DetailViewIcon
                              label="Restore preview"
                              size="medium"
                            />
                          }
                          isDisabled={props.isLoading}
                          appearance="primary"
                          id="restorePreview"
                          type="submit"
                        >
                          Restore preview
                        </Button>
                      </ButtonGroup>
                    ) : (
                      ""
                    )}
                  </FormFooter>
                </div>
              </form>
            )}
          </Form>
        </div>
      </div>
    </div>
  );
};

export default RestoreFilter;
